<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 5h16v10H8l-4 4V5Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" />
        <path d="M8 9h8M8 12h5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" />
    </svg>
</template>